import React, { useState, useEffect } from "react";
import HeroCTR from "../../components/hero/HeroSectionComp";

function ContactUsCTR() {
  const companyemail = "contact@bonvoytourism.com";
  const companyphone = "+971559215470";
  const companyaddress = "Al Saqar Business Tower, Office 117, Sheikh Zayed Rd, Trade Center Second, DIFC, Dubai, United Arab Emirates";
  const companymapsLink = "https://www.google.com/maps/place/Bonvoy+Tourism+%7C+Desert+Safari+And+Tours+Dubai+%7C+Park+Tickets+%7C+Dubai+City+Tour/@25.214,55.277845,9z/data=!4m6!3m5!1s0x3e5f43becd0c7e27:0xdf96e3a5a5936a71!8m2!3d25.2139997!4d55.2778447!16s%2Fg%2F11wc9221z2?hl=en&entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D";
  const companywhatsappLink = `https://wa.me/${companyphone}`;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => setStatus(""), 8000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  useEffect(() => {
    const fallbackTimer = setTimeout(() => setIsMapLoaded(true), 3000);
    return () => clearTimeout(fallbackTimer);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus("");

    try {
      const response = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/contactus", {
      // const response = await fetch("http://localhost:3000/bonvoytourismbackend/api/contactus", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus("Message sent successfully! We'll get back to you soon.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus(result.error || "Failed to send message. Please try again.");
      }
    } catch (error) {
      setStatus("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMapLoad = () => setIsMapLoaded(true);

  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        heading="Contact Us"
        para="We’re Here to Help"
      />

      <div className="w-full mt-12 md:mt-22 relative">
        {!isMapLoaded && (
          <div className="w-full h-[450px] bg-gray-200 animate-pulse rounded-[4px]" />
        )}
        <iframe
          title="Bonvoy Tourism Location Map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d924078.1701508961!2d55.277845!3d25.214!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43becd0c7e27%3A0xdf96e3a5a5936a71!2sBonvoy%20Tourism%20%7C%20Desert%20Safari%20And%20Tours%20Dubai%20%7C%20Park%20Tickets%20%7C%20Dubai%20City%20Tour!5e0!3m2!1sen!2s!4v1767944981575!5m2!1sen!2s"
          width="100%"
          height="450"
          style={{
            border: 0,
            display: isMapLoaded ? "block" : "none",
            borderRadius: "4px",
          }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={handleMapLoad}
        ></iframe>
      </div>

      {/* Form Section */}
      <div className="flex flex-col md:flex-row gap-12 md:gap-30 justify-between mt-12 md:mt-22">
        <div className="flex-[3]">
          <form className="w-full text-[13px] space-y-4" onSubmit={handleSubmit}>
            <div className="flex gap-[12px] items-center w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
              <img src="/images/contact/user.png" alt="user" width={16} height={16} />
              <input
                className="w-full outline-none"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
              />
            </div>

            <div className="flex gap-[12px] items-center w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
              <img src="/images/contact/email.png" alt="email" width={16} height={16} />
              <input
                className="w-full outline-none"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
              />
            </div>

            <div className="flex gap-[12px] items-start w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
              <img src="/images/contact/chat.png" alt="chat" width={16} height={16} />
              <textarea
                className="w-full outline-none resize-none"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows={8}
                required
              />
            </div>

            <button
              type="submit"
              className="bg-[#ff9219] text-white py-[10px] px-[50px] rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Now"}
            </button>
          </form>

          {status && (
            <p
              className={`text-[13px] text-white mt-4 py-[10px] px-[50px] text-center rounded-[4px] ${status.includes("successfully") ? "bg-[#ff9219]" : "bg-red-600"
                }`}
            >
              {status}
            </p>
          )}
        </div>

        {/* Contact Info Section */}
        <div className="space-y-4 flex-1">
          <h3 className="text-[18px] font-medium text-[#606060]">Contact Information</h3>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <a
            href={companymapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-[13px] font-medium text-[#606060] hover:text-[#ff9219] transition"
          >
            {companyaddress}
          </a>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>PHONE:</p>
            <a
              href={`tel:${companyphone}`}
              className="hover:text-[#ff9219] transition"
            >
              {companyphone}
            </a>
          </div>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>EMAIL:</p>
            <a
              href={`mailto:${companyemail}`}
              className="hover:text-[#ff9219] transition"
            >
              {companyemail}
            </a>
          </div>
          <div className="w-full h-[2px] bg-[#ebebeb]" />
          <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
            <p>WHATSAPP:</p>
            <a
              href={companywhatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#ff9219] transition"
            >
              Chat on WhatsApp
            </a>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUsCTR;
